<div class="split left">
  <header>
    <div class="main-header d-flex justify-content-between align-items-center">
      <div class="logo default-pointer" (click)="navigate()">
        <img src="../../assets/automapai-logo.png" class="header-termhub-logo" alt="AutomapAI" />
      </div>
    </div>
  </header>

  <div class="signup-body">
    <div>
      <span class="header-text forgot-header-text green-title"
        ><img src="../../assets/check-circle.png" class="body-circled-check" alt="Check" />Verify Email</span
      >
    </div>

    <div *ngIf="notificationId && userName">
      <div>
        Verifying your acccount. If anything goes wrong
        <a class="form-link" href (click)="!!resendVerificationEmail()">Resend verification email</a>
      </div>
    </div>

    <div *ngIf="!notificationId && userName" class="form-section">
      <span class="default-font">You're almost there! Please check your email to verify your account and get started using TermHub!</span>
      <div class="spam-check-message">Can't find the verification email? Please review your spam/junk folder.</div>
      <div>Didn't receive an email? <a class="form-link" href (click)="!!resendVerificationEmail()">Resend verification email</a></div>
    </div>

    <div class="signup-link">
      <div>Click here to Login <a class="form-link" href="/login">Log In ></a></div>
    </div>
  </div>
</div>
<div class="split right tinted-image"></div>
